import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import EjnFilters from '../components/extrajudicial-notification/ejn-filters/EjnFilters';
import { EjnModal } from '../components/extrajudicial-notification/ejn-modal/EjnModal';
import { EjnPagination } from '../components/extrajudicial-notification/ejn-pagination/EjnPagination';
import { EjnSendNotification } from '../components/extrajudicial-notification/ejn-send-notification-action/EjnSendNotification';
import EjnSendToProtest from '../components/extrajudicial-notification/ejn-send-to-protest-action/EjnSendToProtest';
import EjnTab from '../components/extrajudicial-notification/ejn-tab/EjnTab';
import { EjnTable } from '../components/extrajudicial-notification/ejn-table/EjnTable';
import { useEjnSelected } from '../contexts/ejn';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const ExtrajudicialNotificationsPage = (): React.ReactElement => {
  const query = useQuery();
  const pathId = query.get('id');
  const { setEjnId } = useEjnSelected();

  useEffect(() => {
    setEjnId(pathId || undefined);
  }, [pathId, setEjnId]);

  return (
    <>
      <EjnTab />
      <EjnFilters />
      <EjnTable />
      <EjnPagination />
      <EjnModal />
      <EjnSendNotification />
      <EjnSendToProtest />
    </>
  );
};
